// extracted by mini-css-extract-plugin
export default {"container":"QrReader_container__VWiGh","result":"QrReader_result__DlKpT","camera":"QrReader_camera__S0Hcx"};